import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

import "../assets/css/boardActivities.css";

// const apiUrl =
//     `http://10.1.245.45/api/activityDBMS/?limit=6&owner=arch&category=ผู้บริหาร`;
// const apiUrl = `${process.env.REACT_APP_ACT_API_URL}?limit=6&owner=arch&category=ผู้บริหาร`;
const apiUrl = `${process.env.REACT_APP_ACT_API_URL}v1/arch/category/ผู้บริหาร/5/`;
const apiKey = "551a781fa2e203b0c834f7dcb94789d1aab6c627462be4b77968b73d5588fbf1ecc30e1e02e18ee5"; // new url

// const apiKey = "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0";

export default function BoardActivities() {
    const [boardActivity, setBoardActivity] = useState([]);

    useEffect(() => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: apiKey,
        };
        const fetchData = async () => {
            try {
                const result = await axios.get(apiUrl, headers);
                // const result = await axios.get(apiUrl);
                setBoardActivity(result.data);
            } catch (e) {
                console.log("fetch ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);

    const genBoardActivityCards = boardActivity.map((item, index) => {
        // const d = new Date(item.act_date);
        // const imgPath = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, "0") + '-' + d.getDate().toString().padStart(2, "0");
        return (
            <div key={`item-${index}`} className="item">
                <div key={`palaroid-${index}`} className="polaroid">
                    <Link
                        to={`/news/${item.act_code}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            key={`image-${index}`}
                            src={item.act_poster}
                            alt={item.act_title}
                        />
                    </Link>
                    <div className="caption">{item.act_title}</div>
                </div>
            </div>
        );
    });

    return (
        <>
            <div
                className="d-none d-md-block"
                style={{
                    backgroundColor: "#603b2c",
                    margin: "50px 0 0 0",
                    padding: "20px 10px 50px 10px",
                    textAlign: "center",
                }}
            >
                <div className="text-center mb-0 sectionTitle">
                    ...กิจกรรมผู้บริหาร...
                </div>
                {boardActivity &&
                    boardActivity.length > 0 &&
                    genBoardActivityCards}
            </div>
        </>
    );
}